import Cookies from 'js-cookie'
import confService from '../../services/conf/ConfService'

const COOKIE_KEY = 'pdf_design_config'
const DEFAULT_CONFIG = {
  titulo: 'Catálogo de Produtos',
  subtitulo: '',
  exibir_cabecalho: true,
  capa_filename: null,
  contracapa_filename: null,
  fundo_filename: null,
  espacamento: 'normal',
  horizontalMargin: 'normal',
  marginMode: 'preset',
  customMarginTopCm: 1.0,
  customMarginBottomCm: 0.0,
  customHorizontalMarginCm: 0.8,
  card_model: 'vertical',
  pageNumberPosition: 'center',
  pageNumberInsetCm: 1.0,
}

function loadFromCookie() {
  const saved = Cookies.get(COOKIE_KEY)
  if (saved) {
    try {
      return { ...DEFAULT_CONFIG, ...JSON.parse(saved) }
    } catch {
      return { ...DEFAULT_CONFIG }
    }
  }
  return { ...DEFAULT_CONFIG }
}

function persist(state) {
  Cookies.set(COOKIE_KEY, JSON.stringify(state.config), { expires: 365 })
}

// O DesignDialog edita uma cópia local (`designForm`) e persiste
// tudo de uma vez com `setConfig` ao salvar. Por isso não existe setter por
// campo aqui — só os três de filename, que gravam fora do fluxo de save
// (upload concluído e escolha de imagem já existente no servidor).
export const pdfDesignModule = {
  namespaced: true,
  state: {
    config: loadFromCookie(),
  },
  mutations: {
    SET_CONFIG(state, payload) {
      state.config = { ...state.config, ...payload }
      persist(state)
    },
    SET_CAPA_FILENAME(state, filename) {
      state.config.capa_filename = filename
      persist(state)
    },
    SET_CONTRACAPA_FILENAME(state, filename) {
      state.config.contracapa_filename = filename
      persist(state)
    },
    SET_FUNDO_FILENAME(state, filename) {
      state.config.fundo_filename = filename
      persist(state)
    },
  },
  actions: {
    setConfig({ commit }, payload) {
      commit('SET_CONFIG', payload)
    },
    setCapaFilename({ commit }, filename) {
      commit('SET_CAPA_FILENAME', filename)
    },
    setContracapaFilename({ commit }, filename) {
      commit('SET_CONTRACAPA_FILENAME', filename)
    },
    setFundoFilename({ commit }, filename) {
      commit('SET_FUNDO_FILENAME', filename)
    },
    async uploadCapa({}, payload) {
      const res = await confService.uploadCapa(payload)
      return res?.data
    },
    async getCapas({}) {
      return await confService.getCapas()
    },
    async uploadFundo({}, payload) {
      const res = await confService.uploadFundo(payload)
      return res?.data
    },
    async getFundos({}) {
      return await confService.getFundos()
    },
    // Apaga o arquivo do servidor. Quem limpa a selecao (designForm + cookie)
    // e o onServerImageDeleted do DesignDialog, depois que isto resolve.
    async deleteImagem({}, { tipo, filename }) {
      return await confService.deleteImagem(tipo, filename)
    },
  },
  getters: {
    config: (state) => state.config,
    // Lido tambem pelo CatalogoApp: o modelo escolhido vale para a grade da
    // tela e para o PDF (o cookie antigo, sem a chave, cai em 'vertical').
    cardModel: (state) => state.config.card_model || 'vertical',
  },
}
